/**
 * Product Sales Report API Data Source
 *
 * External API communication for the Product Sales Report feature
 */

import {Http} from '../../../Data/config/Http';
import {API_ROUTES} from '../../../constants/apiRoutes';
import {
  ProductSalesReportDataDTO,
  ProductSalesReportFiltersDTO
} from '../models/productSalesReport.dto';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import {unwrapResponse, handleDataSourceError} from '../../../utils/errorHelpers';
import type {BaseApiResponse} from '../models/report.dto';

export interface ProductSalesReportAPIDataSource {
  getProductSalesReport(filters?: ProductSalesReportFiltersDTO): Promise<BaseApiResponse<ProductSalesReportDataDTO>>;
}

export class ProductSalesReportAPIDataSourceImpl implements ProductSalesReportAPIDataSource {
  async getProductSalesReport(filters?: ProductSalesReportFiltersDTO): Promise<BaseApiResponse<ProductSalesReportDataDTO>> {
    try {
      const queryParams: Record<string, string> = {};

      if (filters?.date_from) {
        queryParams.date_from = filters.date_from;
      }
      if (filters?.date_to) {
        queryParams.date_to = filters.date_to;
      }

      const response = await Http.get<BaseResponse<ProductSalesReportDataDTO>>(
        API_ROUTES.REPORTS.PRODUCTS_SALES,
        {params: queryParams}
      );
      unwrapResponse(response.data, 'حدث خطأ في جلب تقرير مبيعات المنتجات');
      return response.data as BaseApiResponse<ProductSalesReportDataDTO>;
    } catch (error) {
      handleDataSourceError(error);
    }
  }
}

